<div
  class="relative z-0 h-full min-h-[250px] w-full overflow-hidden rounded-lg border border-neutral-3"
  #mapContainer
></div>
